<template>
    <div>
        <div class="header-tool">
            <input @input="handleSearchInput" class="form-control search-input" />
            <el-button size="mini" @click.native="download"><i class="glyphicon glyphicon-download-alt"></i></el-button>
        </div>
        <t-table
            id="mainTable"
            :data="tableData.data"
            :pageSize="queryTableParams.pageSize"
            :curPage="queryTableParams.pageNum"
            :total="tableData.total"
            @current-change="handleTableCurrentChange"
            @sort-change="handleSortable"
            @size-change="handleTablePageSize"
        >
        <t-table-column label="PMID" property="pmid" width="8%" >
            <span slot-scope="{ row }">{{ row.pmid }}</span>
        </t-table-column>
        <t-table-column label="DAID" property="daid" width="8%"  sortable>
            <template slot-scope="{ row }">
                <router-link :to="`/trait/${row.id}`">{{ row.daid }}</router-link>
            </template>
        </t-table-column>
        <t-table-column label="Reporeted Trait" property="reportedTrait" width="20%"  sortable>
            <template slot-scope="{ row }">
                <router-link :to="`/trait/${row.id}`">{{ row.reportedTrait }}</router-link>
            </template>
        </t-table-column>
        <t-table-column label="Trait Label" property="efoOntologyTrait" width="20%" >
            <template slot-scope="{ row }">
                <router-link :to="`/trait/${row.id}`">{{ row.efoOntologyTrait }}</router-link>
            </template>
        </t-table-column>
        <t-table-column label="Trait Ontology ID" property="efoCode" width="12%"  sortable>
            <template slot-scope="{ row }">
                <router-link :to="`/trait/${row.id}`">{{ row.efoCode }} <i class="glyphicon glyphicon-share" style="margin-left: 5px"></i></router-link>
            </template>
        </t-table-column>
        <t-table-column label="Sample Size" property="sampleSize" width="10%" sortable>
            <template slot-scope="{ row }">
                <span>{{row.sampleSize}}</span>
            </template>
        </t-table-column>
        <t-table-column label="Num Case" property="ncase" width="5%" >
            <span slot-scope="{ row }">{{ row.ncase }}</span>
        </t-table-column>
        <t-table-column label="Num Control" property="ncontrol" width="5%" >
            <span slot-scope="{ row }">{{ row.ncontrol }}</span>
        </t-table-column>
        <t-table-column label="Population" property="population" width="8%" >
            <template slot-scope="{ row }">
                <span>{{row.population}}</span>
            </template>
        </t-table-column>
        <t-table-column label="#Associations" property="geneCount" width="10%" >
            <span slot-scope="{ row }">{{ row.associationCount }}</span>
        </t-table-column>
        </t-table>
    </div>
</template>

<script>
import table_mix from "@/common/table_mix";
export default {
    name: "publication_trait",

    mixins: [table_mix],

    props: {
        publicationId: String,
    },

    data() {
        return {};
    },

    created() {
        this.refreshTable();
    },

    computed: {
        getTableDataAjaxUrl() {
            return `publication/${this.publicationId}/association/page`;
        },
    },

    methods: {
        download() {
            window.open(`/api/publication/${this.publicationId}/association/export?keyword=${this.queryTableParams.keyword}`, '_blank')
        },
    },
};
</script>

<style scoped></style>
